/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';

export function TableData({
    id,
    children,
    onClick,
    dense,
}: {
    id?: string;
    children: React.ReactNode;
    onClick?: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
    dense?: boolean;
}) {
    const clickEvent = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        if (onClick !== undefined) {
            onClick(event);
        }
    };

    return (
        <td
            id={id}
            className={`${dense ? 'px-2 py-2' : 'px-4 py-3'} text-sm text-foreground`}
            onClick={(e) => clickEvent(e)}
        >
            {children}
        </td>
    );
}
